import { render } from "./CategoryLoads.vue?vue&type=template&id=405b125d"
import script from "./CategoryLoads.vue?vue&type=script&lang=js"
export * from "./CategoryLoads.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__